import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const PartsCatalogPage = ({ hookData }) => {
    const {
        toast,
        filters,
        partsList,
        totalRecords,
        isLoadingParts,
        formatDate,
        statusBodyTemplate,
        first,
        onPageChange,
        onSort,
        sortField,
        sortOrder,
        th
    } = hookData;

    return (
        <div>
            <Toast ref={toast} />

            <div className="flex justify-content-between align-items-center mb-4">
                <h2 className="m-0">{th('dealerPartsCatalog.partsCatalog.pageTitle')}</h2>
            </div>

            <DataTable
                value={partsList}
                loading={isLoadingParts}
                emptyMessage={th('dealerPartsCatalog.partsCatalog.messages.noRecords')}
                paginator
                rows={filters.pageSize}
                rowsPerPageOptions={[10, 20, 50]}
                totalRecords={totalRecords}
                lazy
                first={first}
                onPage={onPageChange}
                onSort={onSort}
                sortField={sortField}
                sortOrder={sortOrder}
                stripedRows
                showGridlines
            >
                <Column field="partCode" header={th('dealerPartsCatalog.partsCatalog.table.partCode')} sortable />
                <Column field="partDesc" header={th('dealerPartsCatalog.partsCatalog.table.partDescription')} sortable />
                <Column field="uom" header={th('dealerPartsCatalog.partsCatalog.table.uom')} sortable />
                <Column field="quantity" header={th('dealerPartsCatalog.partsCatalog.table.quantity')} sortable body={(rowData) => rowData.quantity?.toLocaleString(th('common.locale')) || '0'} />
                <Column field="branchInfo" header={th('dealerPartsCatalog.partsCatalog.table.branchInfo')} sortable />
                <Column field="isActive" header={th('dealerPartsCatalog.partsCatalog.table.status')} sortable body={statusBodyTemplate} />
                <Column field="createdDate" header={th('dealerPartsCatalog.partsCatalog.table.createdDate')} sortable body={(rowData) => formatDate(rowData.createdDate)} />
                <Column field="createdName" header={th('dealerPartsCatalog.partsCatalog.table.createdBy')} sortable />
            </DataTable>
        </div>
    );
};

export default PartsCatalogPage;
